import React, { useState } from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import actions from '../actions';
import styles from './ToolBarButton.module.scss';

const ToolBarButton = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const IconComp = props.icon;
  const current = props.views.includes(props.currentView.view);
  const active = current && props.showSidebar;

  const getIconColor = () => {
    let iconColor = '#8e8e92'
    if (isHovered || active) {
      iconColor = '#fff'
    } else if (current) {
      iconColor = '#f37735'
    }
    return iconColor
  };

  const onButtonClick = (e) => {    
    if (active || current) {
      props.toggleSidebar();
    } else {
      props.navigateAndClear(props.view, props.savedContentTab);
    }
  };

  const buttonClasses = [
    styles.toolbarButton,
    active ? styles.active : ''
  ].join(' ');

  return (
    <div className={styles.toolbarButtonContainer}>
      <button
        className={buttonClasses}
        // title={props.title}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onButtonClick}
      >
        <IconComp className={styles.buttonIcon} width={20} height={20} color={getIconColor()} />
      </button>
      <span className={`${styles.tooltip}`}>{props.title}</span>
    </div>
  );
};

ToolBarButton.propTypes = {
  currentHistory: PropTypes.array,
  currentView: PropTypes.object,
  highlightColor: PropTypes.string,
  icon: PropTypes.any,
  savedContentTab: PropTypes.string,
  showSidebar: PropTypes.bool,
  title: PropTypes.string,
  view: PropTypes.string,
  views: PropTypes.arrayOf(PropTypes.string),
  // actions
  navigateAndClear: PropTypes.func,
  toggleSidebar: PropTypes.func,
};

ToolBarButton.defaultProps = {
  highlightColor: '#fff',
};

export default connect((model) => {
    const { showSidebar, sidebarHistoryStack: currentHistory, sidebarView: currentView } = model.app
    const { savedContentTab } = currentView.metadata
    return {
      currentHistory,
      currentView,
      savedContentTab,
      showSidebar,
    }
  },
  actions
)(ToolBarButton);
